import { getViewMode } from '../../app/selectors/search-params-selectors';
import { isOwner } from '../../app/selectors/current-user-selectors';
import createAction from '../../app/services/create-action';

export const CONTENT_MIGRATION_FETCH_STATUS_REQUEST = 'contentMigration/FETCH_STATUS_REQUEST';
export const CONTENT_MIGRATION_FETCH_STATUS_SUCCESS = 'contentMigration/FETCH_STATUS_SUCCESS';
export const CONTENT_MIGRATION_FETCH_STATUS_FAILURE = 'contentMigration/FETCH_STATUS_FAILURE';
export const CONTENT_MIGRATION_SET_STATUS = 'contentMigration/SET_STATUS';

export const contentMigrationFetchStatusRequest = createAction(CONTENT_MIGRATION_FETCH_STATUS_REQUEST);
export const contentMigrationFetchStatusSuccess = createAction(CONTENT_MIGRATION_FETCH_STATUS_SUCCESS);
export const contentMigrationFetchStatusFailure = createAction(CONTENT_MIGRATION_FETCH_STATUS_FAILURE);
export const contentMigrationSetStatus = createAction(CONTENT_MIGRATION_SET_STATUS);

export const MIGRATION_STATUS_PATH = '/_api/content-migration/details';
export const getMigrationStatusPath = viewMode => `${MIGRATION_STATUS_PATH}?viewMode=${viewMode}`;

export const contentMigrationFetchStatus = viewMode => (dispatch, getState, { request }) => {
  dispatch(contentMigrationFetchStatusRequest());

  const promise = request(getMigrationStatusPath(viewMode || getViewMode(getState())));
  return promise
    .then(
      details => dispatch(contentMigrationFetchStatusSuccess(details)),
      () => dispatch(contentMigrationFetchStatusFailure()),
    )
    .then(() => promise);
};

export const fetchContentMigrationStatusForBusinessManager = () => (dispatch, getState) => {
  const state = getState();
  return isOwner(state) ? dispatch(contentMigrationFetchStatus('editor')) : Promise.resolve();
};
